import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import privacyimg from "../assets/privacyimg.webp";
import Navbar from "./Navbar";
import Footer from "./Footer";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <Navbar />
      <div className="container py-2 py-md-3 py-lg-4">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-11 mt-5 mt-lg-4 ">
            <div
              className="card border-0 rounded-4 mb-4 mt-4 mt-lg-5"
              style={{ backgroundColor: "#e6effd" }}
            >
              <div className="card-body py-3 py-md-4">
                <div className="row align-items-center justify-content-center">
                  <div className="col-md-6 col-lg-5 order-md-1 mb-4 mb-md-0">
                    <div className="px-md-3 text-center text-md-start">
                      <h1 className="display-5 mx-3 fw-semibold ">
                        Privacy <br className="d-none d-md-block" />
                        <span>Policy</span>
                      </h1>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-7 order-md-2 text-center text-md-end">
                    <div className="px-md-3 mx-5">
                      <img
                        src={privacyimg}
                        alt="Privacy"
                        className="img-fluid"
                        style={{ maxHeight: "300px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12 col-lg-11">
            <div className="privacy-content mx-5">
              <section className="mb-5">
                <h2 className="fs-2 fw-semibold mb-4">Legal Notice</h2>
                <p className="text-muted">
                  VISITORS TO THIS WEB SITE ARE BOUND BY THE FOLLOWING TERMS AND
                  CONDITIONS. ('TERMS') PLEASE READ THIS DOCUMENT CAREFULLY
                  BEFORE CONTINUING TO USE THIS SITE. IF YOU DO NOT AGREE WITH
                  ANY OF THESE TERMS, PLEASE DO NOT USE THIS SITE. IF YOU HAVE
                  ANY QUERIES ABOUT THESE TERMS, PLEASE CONTACT
                  SERVICE@shubhpaisa.com
                </p>
                <p className="text-muted small">
                  Disclaimer of Warranties, Inaccuracies or Errors | ShubhPaisa
                  Finance Disclaimer | Availability | Third Party Interaction
                  and Links to Third Party Sites | Copyrights | Trademarks |
                  General Terms and Conditions | Applicable Law and Jurisdiction
                  | Disclaimer of Warranties, Inaccuracies or Errors
                </p>
                <p className="text-muted">
                  Although ShubhPaisa Finance tries to ensure that all
                  information and recommendations, whether in relation to the
                  products, services, offerings or otherwise (hereinafter
                  'Information') provided as part of this website is correct at
                  the time of its inclusion on the web site, ShubhPaisa Finance
                  does not guarantee the accuracy of the Information. ShubhPaisa
                  Finance makes no representations or warranties as to the
                  completeness or accuracy of the Information. ShubhPaisa
                  Finance makes no commitment to update or correct any
                  Information that appears on the Internet or on this web site.
                  Information is supplied upon the condition that the persons
                  receiving the same will make their own determination as to its
                  suitability for their purposes prior to use or in connection
                  with the making of any decision.
                </p>
                <p className="text-muted">
                  THIS WEBSITE IS PROVIDED TO YOU ON AN "AS IS" AND "WHERE-IS"
                  BASIS, WITHOUT ANY WARRANTY. SHUBHPAISA FINANCE, FOR ITSELF
                  AND ANY THIRD PARTY PROVIDING MATERIALS, SERVICES, OR CONTENT
                  TO THIS WEBSITE, MAKES NO REPRESENTATIONS OR WARRANTIES,
                  EITHER EXPRESSED, IMPLIED, STATUTORY OR OTHERWISE OF
                  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
                  NON-INFRINGEMENT OF THIRD PARTY RIGHTS, WITH RESPECT TO THE
                  WEBSITE, THE INFORMATION OR ANY PRODUCTS OR SERVICES TO WHICH
                  THE INFORMATION REFERS.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="fs-2 fw-semibold mb-4">
                  ShubhPaisa Finance Disclaimer
                </h2>
                <p className="text-muted">
                  ShubhPaisa Finance has its own separate identity but in this
                  web site we may sometimes use 'ShubhPaisa & ShubhPaisa Group
                  Company', 'we' or 'us' when we refer to ShubhPaisa Finance
                  company in general or where no useful purpose is served by
                  identifying any particular ShubhPaisa Finance company
                </p>
              </section>

              <section className="mb-5">
                <h2 className="fs-2 fw-semibold mb-4">Availability</h2>
                <p className="text-muted">
                  ShubhPaisa Finance controls and operates this web site from
                  India and makes no representation that the materials are
                  appropriate or will be available for use in other locations.
                  If you use this web site from outside India, you are entirely
                  responsible for compliance with all applicable local laws.
                </p>
                <p className="text-muted">
                  In case ShubhPaisa Finance has or develops more than one
                  website offering products, services, content and various other
                  functionalities (collectively the 'Services') to specific
                  regions worldwide. The Services offered in one region may
                  differ from those in other regions due to availability, local
                  or regional laws, shipment and other considerations.
                </p>
                <p className="text-muted">
                  Information that ShubhPaisa Finance publishes on the World
                  Wide Web may contain references or cross references to
                  ShubhPaisa Finance products, programs and services that are
                  not announced or available in your country. Such references do
                  not imply that ShubhPaisa Finance intends to announce such
                  products, programs or services in your country.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="fs-2 fw-semibold mb-4">Copyrights</h2>
                <p className="text-muted">
                  This web site contains material, including text, graphics and
                  sound, which is protected by copyright and/or other
                  intellectual property rights. All copyright and other
                  intellectual property rights in this material are either owned
                  by ShubhPaisa Finance or have been licensed to ShubhPaisa
                  Finance by the owner(s) of those rights so that it can use
                  this material as part of this web site.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="fs-2 fw-semibold mb-4">You may:</h2>
                <div className="text-muted">
                  <p>
                    • Use and display the materials only on your personal
                    computer only for personal use. ShubhPaisa Finance grants
                    you a limited, personal, non-exclusive and non-transferable
                    license only for such use.
                  </p>
                  <p>
                    • Print copies of the information on this site for your
                    personal use and store the files on your computer for
                    personal use.
                  </p>
                </div>
              </section>

              <section className="mb-5">
                <h2 className="fs-2 fw-semibold mb-4">You may not:</h2>
                <div className="text-muted">
                  <p>
                    • Copy (whether by printing onto paper, storing on disk,
                    downloading or in any other way), distribute (including
                    distributing copies), download, display, perform, reproduce,
                    distribute, modify, edit, alter, enhance, broadcast or
                    tamper with in any way or otherwise use any material
                    contained in the web site except as set out under "You may".
                  </p>
                  <p>
                    • Copy and distribute this information on any other server,
                    or modify or re-use text or graphics on this system or
                    another system. No reproduction of any part of the web site
                    may be sold or distributed for commercial gain.
                  </p>
                  <p>
                    • Remove any copyright, trade mark or other intellectual
                    property notices contained in the original material from any
                    material copied or printed off from the web site; link to
                    this web site; without our express written consent.
                  </p>
                </div>
              </section>

              <section className="mb-5">
                <h2 className="fs-2 fw-semibold mb-4">Trademarks</h2>
                <p className="text-muted">
                  The ShubhPaisa Finance™ and all products and logos denoted
                  with TM are trademarks or registered trademarks of ShubhPaisa
                  Finance or its parent. ShubhPaisa Finance trademarks may not
                  be used in connection with any product or service that is not
                  a ShubhPaisa Finance product or service.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="fs-2 fw-semibold mb-4">
                  General Terms and Conditions
                </h2>
                <p className="text-muted">
                  ShubhPaisa Finance does not routinely monitor your postings to
                  the web site but reserves the right to do so. However, in our
                  efforts to promote good citizenship within the Internet
                  community, if ShubhPaisa Finance becomes aware of
                  inappropriate use of the web site or any of its Services,
                  ShubhPaisa Finance will respond in any way that, in its sole
                  discretion, ShubhPaisa Finance deems appropriate.
                </p>
                <p className="text-muted">
                  ShubhPaisa Finance reserves the right to terminate access to
                  this web site at any time and without notice. Further this
                  limited license terminates automatically, without notice to
                  you, if you breach any of these Terms. Upon termination, you
                  must immediately destroy any downloaded and printed materials.
                </p>
                <p className="text-muted">
                  If you have a question or complaint, please contact us at
                  support@shubhpaisa.com <br /> ShubhPaisa Finance reserves all
                  other rights.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="fs-2 fw-semibold mb-4">
                  Applicable Law and Jurisdiction
                </h2>
                <p className="text-muted">
                  These terms and conditions are governed by and to be
                  interpreted in accordance with laws of India, without regard
                  to the choice or conflicts of law provisions of any
                  jurisdiction. You agree, in the event of any dispute arising
                  in relation to these terms and conditions or any dispute
                  arising in relation to the web site whether in contract or
                  tort or otherwise, to submit to the jurisdiction of the courts
                  located at Mumbai, India for the resolution of all such
                  disputes.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;